import * as React from 'react';
import Text, { Props as TextProps } from '../Text/Text';

export interface Props extends TextProps {}

/**
 * Provides specific styling for a label that accompanies an
 * input.
 */
const InputLabel: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Text { ...props }
        Component="label"
        margin="x1"
        size="x3"
        textColor="grape-4"
        weight="bold" />
  );
};

export default InputLabel;
